import {
    Controller
} from "stimulus"
import randomstring from 'randomstring'

export default class extends Controller {
    get label()
    {
        return this.element.getAttribute('aria-label')
    }

    get hasLabel()
    {
        return !!this.label
    }

    get labelledby()
    {
        return this.element.getAttribute('aria-labelledby')
    }

    get hasLabelledby()
    {
        return !!this.labelledby
    }

    get header()
    {
        return this.element.querySelector('h1, h2, h3, h4, h5')
    }


    get hasHeader()
    {
        return !!this.header
    }


    /**
     * The controller has loaded.
     */
    connect() {
        if (!this.hasLabel && !this.hasLabelledby) {
            this.setLabelFromHeader()
        }
    }

    setLabelFromHeader()
    {
        if (!this.hasHeader) {
            return false
        }

        let header = this.header

        if (!header.id) {
            header.id = 'section-label-' + randomstring.generate({
                length: 12,
                charset: 'alphabetic',
                capitalization: 'lowercase'
            })
        }

        this.element.setAttribute('aria-labelledby', header.id)
    }
}
